'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconCopy = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M22 5.5a.5.5 0 0 0-.146-.353l-5-5A.502.502 0 0 0 16.5 0h-9a.5.5 0 0 0-.5.5V2h3.915a.5.5 0 0 1 .353.147l5.585 5.586c.094.094.147.22.147.353V21h4.5a.5.5 0 0 0 .5-.5v-15zM16 6V1l5 5h-5z' }),
    _react2.default.createElement('path', { d: 'M1.5 3a.5.5 0 0 0-.5.5v20a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-15a.507.507 0 0 0-.146-.354l-5-5A.504.504 0 0 0 10.5 3h-9zM10 9V4l5 5h-5z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M21.961 5.308a.495.495 0 0 0-.108-.162L16.854.147a.492.492 0 0 0-.162-.107A.482.482 0 0 0 16.5 0h-9a.5.5 0 0 0-.5.5V3H1.5a.5.5 0 0 0-.5.5v20a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V21h5.5a.5.5 0 0 0 .5-.5v-15a.499.499 0 0 0-.039-.192zM17 1.707L20.293 5H17V1.707zM15 23H2V4h8v4.5a.5.5 0 0 0 .5.5H15v14zm-.707-15H11V4.707L14.293 8zM16 20V8.5a.499.499 0 0 0-.147-.354l-4.999-4.999a.492.492 0 0 0-.162-.107A.482.482 0 0 0 10.5 3H8V1h8v4.5a.5.5 0 0 0 .5.5H21v14h-5z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M21.961 5.308a.495.495 0 0 0-.108-.162L16.854.147a.492.492 0 0 0-.162-.107A.482.482 0 0 0 16.5 0h-9a.5.5 0 0 0-.5.5V3H1.5a.5.5 0 0 0-.5.5v20a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V21h5.5a.5.5 0 0 0 .5-.5v-15a.499.499 0 0 0-.039-.192zM17 1.707L20.293 5H17V1.707zM15 23H2V4h8v4.5a.5.5 0 0 0 .5.5H15v14zm-.707-15H11V4.707L14.293 8zM16 20V8.5a.499.499 0 0 0-.147-.354l-4.999-4.999a.492.492 0 0 0-.162-.107A.482.482 0 0 0 10.5 3H8V1h8v4.5a.5.5 0 0 0 .5.5H21v14h-5z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconCopy.displayName = 'IconCopy';
exports.default = IconCopy;